import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"
import type { ListPreparedPushNotificationsResponse } from "../types"

export function usePreparedPushes() {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["preparedPushes"],
    queryFn: async () => {
      return await apiFetch<ListPreparedPushNotificationsResponse>("/admin/prepared-pushes", {
        token,
        method: "GET",
      })
    },
  })
}

